/* eslint-disable jsx-a11y/anchor-is-valid */
import { Component } from "react";
import {set_datapage, SetLanguage, getLanguage} from 'redux/actions/DataPageAction'
import { connect } from "react-redux";
import { createHChart } from "layouts/mainsection/components/CHighchartToolsTraffic";
import numeral from "numeral";
import { styleInfo as style } from "./info";
import ModalCard from "layouts/mainsection/components/ModalCard";
import ModalBox from "layouts/mainsection/components/ModalBox";
import MTDDetallesBase from "./MTDDetallesBase";




class FITMultasSancionesFiveEsp extends Component {
  state = {
    modals: []
  }
  componentDidMount () {
  
    
  }
  fnTBody = () => {
    return this.props.data.map((item, index) => {
      // let textTarget = 'modal-FITMultasSancionesFiveEspN' + index
      // this.setState({
      //   modals: [
      //     ...this.state.modals,
      //     <MTDDetalles key={ index } id={ textTarget } data={ item.n.data } />
          
      //   ]

      // })
      return <tr key={ index } draggable="false" className="">
        <td className="">{ item.title }</td>
        <td className="has-text-centered">{ numeral(item.n).format('0,0') }</td>
        <td className="has-text-centered">{ numeral(item.min).format('0,0') }</td>
        <td className="has-text-centered">{ numeral(item.max).format('0,0') }</td>
        <td className="has-text-centered">{ numeral(item.promedi).format('0,0.00') }</td>
        <td className="has-text-centered">{ numeral(item.de).format('0,0.00') }</td>
      </tr>
    }) 
  }
  fnModals = () => {
    return this.props.data.map((item, index) => {
      let textTarget = 'modal-FITMultasSancionesFiveEspN' + index

      return <MTDDetallesBase 
        title={ item.title }
        key={ index } 
        id={ textTarget } 
        data={ item.n.data } />
   
    }) 
  }
  render () {
   //[{year: 2002, value: 10.5}]
    
    return this.props.data.length > 0 ? 
    <div style={{fontSize: '0.9em'}}>
      <div className="has-text-centered" style={{fontSize: '0.9em'}}>

        <p style={{
              color: '#000',
              fontSize: '1.4em',
              fontWeight: 'bold',
              fill: '#000'
        }}>{ this.props.title }</p>
        </div>
      <div className="table-wrapper has-mobile-cards table-container">
        <table className="table is-fullwidjth db-trafico is-striped is-hoverable">
          <thead>
            <tr>
              
              <th draggable="false" className="is-sortable is-unselectable is-current-sort">
                <div className="th-wrap has-text-centered"><span className="is-relative">&nbsp;</span></div>
              </th>
              <th draggable="false" className="is-sortable is-unselectable has-text-centered">
                <div className="th-wrap has-text-centered"><span className="is-relative">N</span></div>
              </th>
              <th draggable="false" className="is-sortable is-unselectable has-text-centered">
                <div className="th-wrap has-text-centered"><span className="is-relative">Min</span></div>
              </th>
              <th draggable="false" className="has-text-centered">
                <div className="th-wrap has-text-centered"><span className="is-relative">Max </span></div>
              </th>
              <th draggable="false" className="has-text-centered">
                <div className="th-wrap has-text-centered"><span className="is-relative">Promedio</span></div>
              </th>
              <th draggable="false" className="has-text-centered">
                <div className="th-wrap has-text-centered"><span className="is-relative">D.E</span>
                &nbsp;
                <span className="has-tooltip-bottom"  data-tooltip="Desviación Estándar">
                  <i className="fas fa-info-circle"  style={ style }></i>
                </span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
           { this.fnTBody() }
          </tbody>
          
        </table>
        {/* { this.fnModals() } */}
      </div>
      <div className="has-text-centered" style={{fontSize: '0.9em'}}>
        <p className="px-6" style={{
              color: '#000',
              fontSize: '1.1em',
              
              fill: '#000'
        }}><i>{ this.props.description }</i></p>
        </div>
    </div>
    : null
    
  }
}
export default connect(getLanguage, {set_datapage, SetLanguage})(FITMultasSancionesFiveEsp)